import find from 'lodash/find'
import Toast from '@/frontapp/mixins/actions/Toast'
import BaseElement from './BaseElement'
import FilesSort from './FilesSort'
import Gallery from './Gallery'

export default {
  mixins: [BaseElement, FilesSort, Gallery],
  methods: {
    dropFiles({ item, index }) {
      const existingChildren = item.parent__bc_document_data_rev_id !== this.element.id && find(this.element.children, { file: { id: item.file.id } })
      if (existingChildren) {
        Toast(
          'error',
          this.$t('File already exist in list'),
          this.$t(
            'File "%fileName%" already exist in this list of files under the name "%fileListName%"',
            {
              fileName: item.file.name,
              fileListName: existingChildren.file.name
            }
          )
        )
        return
      }

      this.drop({ item, index })
    }
  },
  computed: {
    publicUpload() {
      return this.data.public_upload && this.bcDocumentStore.document.published__bc_document_rev_id && this.bcDocumentStore.documentRev === null
    }
  },
}